import { AxiosError, AxiosResponse } from "axios";
import { call, put, select } from "redux-saga/effects";

// Redux
import { ApplicationState } from "..";
import { AddCart, Cart, CartState, ClearAllCart, LoadCart, RemovingCart, UpdateCart } from "./cartTypes";
import { errorCart, removeCartReducer, saveCart, updateCartReducer, resetReducerCart, loadCart } from "./cartActions";

// API/MODELS
import { quoteApi, quoteSupplierItemApi } from "@/main/api";
import { QuoteSupplierItemSaveCartResponse, QuoteGetItemConditionsWrapper } from "@/main/models/response";
import { QuoteGetItemsFilterRequest } from "@/main/models/request/quoteRequest";
import { Result } from "@/main/models/common/resultResponse";
import {
	QuoteSupplierItemSaveCartRequest,
	QuoteSupplierItemUpdateQuantityRequest,
	QuoteSupplierRemoveCartRequest,
} from "@/main/models/request";

// Utils
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";
import { destructGetItemsResponse, transformCartItemsToCart } from "./cartUtils";

export function* loadCartSaga(action: LoadCart) {
	try {
		const request: QuoteGetItemsFilterRequest = {
			quoteGuid: action.payload.guidQuote,
		};
		const response: AxiosResponse<Result<QuoteGetItemConditionsWrapper>> = yield call(quoteApi.getItems, request);

		const {
			dataCart,
			dataCartNoSupplierAssigned,
			dataCartUnansweredItems,
			dataCartUnansweredCanceledItems,
			dataCartUnansweredRequotedItems,
		} = destructGetItemsResponse(response.data.result);

		const formattedPart = transformCartItemsToCart(dataCart, action.payload.guidQuote);

		yield put(
			saveCart(
				formattedPart,
				dataCartNoSupplierAssigned,
				dataCartUnansweredItems,
				dataCartUnansweredCanceledItems,
				dataCartUnansweredRequotedItems,
				false,
				null,
			),
		);
	} catch (exception) {
		yield put(errorCart());
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);
		}
	}
}

export function* addCartSaga(action: AddCart) {
	try {
		const request: QuoteSupplierItemSaveCartRequest = {
			guid: action.payload.data.parts[0].guid,
			guidPart: action.payload.data.parts[0].guidPart,
			externalPartId: action.payload.data.parts[0].externalPartId,
			deliveryBySupplier: action.payload.data.parts[0].deliveryBySupplier,
			guidQuote: action.payload.data.guidQuote,
			guidSupplier: action.payload.data.guid,
			idPartType: action.payload.data.parts[0].idPartType,
			guidSupplierInventoryWarehouse: action.payload.data.parts[0].guidSupplierInventoryWarehouse,
			quantity: action.payload.data.parts[0].quantity,
		};
		const response: AxiosResponse<Result<QuoteSupplierItemSaveCartResponse>> = yield call(
			quoteSupplierItemApi.saveCart,
			request,
		);

		if (response.data.result) {
			yield put(loadCart(action.payload.data.guidQuote));
		}
	} catch (exception) {
		yield put(errorCart());
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);
		}
	}
}
export function* updateCartSaga(action: UpdateCart) {
	try {
		const cartState: CartState = yield select((state: ApplicationState) => state.cart);
		const findCart = cartState.cartItems.data.find((item: Cart) => item.guid === action.payload.guidSupplier);

		if (findCart) {
			const request: QuoteSupplierItemUpdateQuantityRequest = {
				guid: String(action.payload.data.guidQuoteSupplierItem),
				guidQuote: findCart.guidQuote,
				guidQuoteItem: String(action.payload.data.guid),
				quantity: action.payload.data.quantity,
				guidSupplierInventoryWarehouse: action.payload.data.guidSupplierInventoryWarehouse,
				idPartType: action.payload.data.idPartType,
			};
			yield call(quoteSupplierItemApi.updatequantitypart, request);
			yield put(updateCartReducer(action.payload.data, action.payload.guidSupplier));
		}
	} catch (exception) {
		yield put(errorCart());
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);
		}
	}
}

export function* removeCartSaga(action: RemovingCart) {
	try {
		const { payload } = action;
		const { guidQuoteSupplierItem, removeQuoteItem } = payload;

		const request: QuoteSupplierRemoveCartRequest = {
			guidQuoteSupplierItem: guidQuoteSupplierItem,
			removeQuoteItem: removeQuoteItem,
		};
		yield call(quoteSupplierItemApi.deleteCart, request);
		yield put(removeCartReducer(action.payload.guidQuoteSupplierItem, action.payload.idPart, false, []));
	} catch (exception) {
		yield put(errorCart());
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);
		}
	}
}

export function* clearAllCartSaga(action: ClearAllCart) {
	try {
		yield call(quoteSupplierItemApi.clearAllCart, action.payload.guidQuote);
		yield put(resetReducerCart());
	} catch (exception) {
		yield put(errorCart());
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);
		}
	}
}
